<!-- PROGRESS BAR -->
<cdk-progress-bar></cdk-progress-bar>
<!-- / PROGRESS BAR -->

<!-- VERTICAL LAYOUT 1 -->
@if (cdkConfig.layout.style === 'vertical-layout-1') {
  <vertical-layout-1></vertical-layout-1>
}
<!-- / VERTICAL LAYOUT 1 -->

<!-- VERTICAL LAYOUT 2 -->
@if (cdkConfig.layout.style === 'vertical-layout-2') {
  <vertical-layout-2></vertical-layout-2>
}
<!-- / VERTICAL LAYOUT 2 -->

<!-- VERTICAL LAYOUT 3 -->
@if (cdkConfig.layout.style === 'vertical-layout-3') {
  <vertical-layout-3></vertical-layout-3>
}
<!-- / VERTICAL LAYOUT 3 -->

<!-- HORIZONTAL LAYOUT 1 -->
@if (cdkConfig.layout.style === 'horizontal-layout-1') {
  <horizontal-layout-1></horizontal-layout-1>
}
<!-- / HORIZONTAL LAYOUT 1 -->

<cdk-sidebar name="themeOptionsPanel" class="theme-options-sidebar" position="right" [invisibleOverlay]="true">
  <cdk-theme-options></cdk-theme-options>
</cdk-sidebar>
<!-- / THEME OPTIONS PANEL -->
